// SPDX-License-Identifier: AGPL-3.0-or-later

// LOCAL-ONLY (emoji-plan.md section 8, Q9): favourites and recent use are stored as `custom:<guild id>:<emoji id>`.
// Moving an emoji to another server keeps its id but changes the guild, so the stored key no longer matches. These
// helpers find a stored key by emoji id when the guild part differs. Exclude from upstream sync.

// EmojiPicker's CUSTOM_EMOJI_USAGE_KEY_PREFIX; not imported, as EmojiPicker imports this module.
const CUSTOM_EMOJI_USAGE_KEY_PREFIX = 'custom:';

/** The emoji id of a custom usage key, or null for a Unicode key. */
export function customEmojiIdOfUsageKey(key: string): string | null {
	if (!key.startsWith(CUSTOM_EMOJI_USAGE_KEY_PREFIX)) return null;
	const id = key.slice(key.lastIndexOf(':') + 1);
	return /^\d+$/.test(id) ? id : null;
}

/** emoji id -> the stored key naming it (the first one, if several do). */
export function buildCustomIdIndex(keys: Iterable<string>): Map<string, string> {
	const index = new Map<string, string>();
	for (const key of keys) {
		const id = customEmojiIdOfUsageKey(key);
		if (id && !index.has(id)) index.set(id, key);
	}
	return index;
}

/** The stored key that stands for `key`: itself if stored, else one with the same emoji id; null when none. */
export function findStoredKey(
	key: string,
	stored: ReadonlySet<string>,
	idIndex: ReadonlyMap<string, string>,
): string | null {
	if (stored.has(key)) return key;
	const id = customEmojiIdOfUsageKey(key);
	return id ? (idIndex.get(id) ?? null) : null;
}
